(function() {
	'use strict';

	angular
		.module('pwc.controllers')
		.controller('WineAgingController', WineAgingController);

	WineAgingController.$inject = ['$mdDialog', 'lodash', 'wine', 'wineAgingPotential', '$mdToast', '$log'];

	function WineAgingController($mdDialog, lodash, wine, wineAgingPotential, $mdToast, $log){

		/* jshint validthis: true */
		var self = this;

		self.wine = wine;

		self.wineAgingPotential = wineAgingPotential;

		self.errorMessage = null;

		self.quality = null;

		self.calculate = calculate;
		self.cancel = cancel;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){
			self.quality = lodash.get(wine, 'cellar.aging.quality');
		}

		function calculate(ev){

			if (! self.quality){

				self.errorMessage = 'You must set the wine quality below in order to calculate maturity dates.';

				return false;
			}

			lodash.set(self.wine, 'cellar.aging.quality', self.quality);

			self.wineAgingPotential.calculate();

			// update the wine model
			lodash.set(self.wine, 'cellar.aging.after', self.wineAgingPotential['after']);
			lodash.set(self.wine, 'cellar.aging.by', self.wineAgingPotential['by']);

			$log.debug('Aging Maturity Calculation', self.wineAgingPotential);

			self.wine.updateMaturity();

			toast("Drink After and Drink By dates updated to " + self.wineAgingPotential['after'] + " and " + self.wineAgingPotential['by'] + "! Don't forget to save when done editing.");

			$mdDialog.hide();
		}

		function cancel(){
			$mdDialog.hide();
		}

		// @TODO centralize into service
		function toast(message){
			$mdToast.show(
				$mdToast.simple()
					.content(message)
					.position('top right')
					.hideDelay(6000)
			);
		}
	}

})();
